import * as XLSX from "xlsx";
import formatDate from "../../../../helpers/formatDate";
import formatHour from "../../../../helpers/formatHour";

const XlsxMonthly = (props) => {
  const wb = XLSX.utils.book_new();

  const data = [
    [
      "CONTAINER",
      "VIAGEM DE ENTRADA",
      "PRIMEIRO MONITORAMENTO MÊS",
      "ÚLTIMO MONITORAMENTO MÊS",
      "SETPOINT",
      "TOTAL",
      "TOTAL AM",
      "TOTAL PM",
      "FALHAS",
      "EVIDÊNCIAS DE PROBLEMAS",
      "SUBTOTAL (R$)",
    ],
  ];
  const keys = Object.keys(props?.reportData.containers);
  keys.forEach((key) => {
    const valueMonitoringUser = props.reportData.valuePerMonitoring;
    const e = [];
    const dateErr = [];
    props.reportData.containers[key].monitoring.forEach((m) => {
      if (m.errType > 0) {
        e.push(m.errType);
        const fDate = formatDate(m.read_timestamp);
        const fHour = parseFloat(formatHour(m.read_timestamp));
        if (fHour <= 12) {
          dateErr.push(`${fDate} - AM        `);
        } else {
          dateErr.push(`${fDate} - PM        `);
        }
      }
    });
    const hourIn = parseFloat(formatHour(props.reportData.containers[key].date_in));
    const hourOut = parseFloat(formatHour(props.reportData.containers[key].date_out));
    const dateIn = formatDate(props.reportData.containers[key].date_in);
    const dateOut = formatDate(props.reportData.containers[key].date_out);

    data.push([
      key,
      props.reportData.travel,
      hourIn <= 12 ? `${dateIn} - AM` : `${dateIn} - PM`,
      hourOut <= 12 ? `${dateOut} - AM` : `${dateOut} - PM`,
      props.reportData.containers[key].temperature,
      props.reportData.containers[key].monitoring.length,
      props.reportData.containers[key].am,
      props.reportData.containers[key].pm,
      props.reportData.containers[key].err,
      dateErr.join(""),
      props.reportData.containers[key].monitoring.length * valueMonitoringUser,
    ]);
  });

  console.log(props);
  wb.Props = {
    Title: "Espelho diário",
    Subject: "Relatório diário espelho em formato de excel",
    Author: "Kevlan Costa",
    CreatedDate: new Date(),
  };

  wb.SheetNames.push("Relatório Mensal");

  const ws = XLSX.utils.aoa_to_sheet(data);

  wb.Sheets["Relatório Mensal"] = ws;

  XLSX.writeFile(wb, "Relatório Mensal.xlsx", { bookType: "xlsx", type: "binary" });
};

export default XlsxMonthly;
